// generated by scripts/write-build-id.js — do not edit
export const BUILD_ID = "20261104T145859-nogit";
